export default "__VITE_ASSET__Aw$yqAoa__"